import React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import { Input } from "components/bootstrap";
const Error = styled.span`
  display: block;
  font-weight: normal;
  padding-left: 15px;
  font-size: 0.85em;
`;
const ErrorContainer = styled.span`
  display: flex;
  align-items: center;
`;
const Label = ({ label, error }) => {
  if (error) {
    return /* @__PURE__ */ React.createElement(ErrorContainer, null, label, /* @__PURE__ */ React.createElement(Error, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), error));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, " ", label);
};
const ValidatedInput = ({
  id,
  label,
  type,
  className = void 0,
  onChange = () => {
  },
  help = "",
  fieldData = {
    dirty: false,
    error: void 0,
    value: void 0
  },
  ...restProps
}) => {
  const { dirty, error, value } = fieldData;
  const checkValidity = (event) => {
    if (dirty) {
      const errorOutput = "";
      onChange(event, { error: errorOutput });
    }
  };
  if (type === "file") {
    return /* @__PURE__ */ React.createElement(
      Input,
      {
        ...restProps,
        id,
        type,
        onChange,
        onBlur: checkValidity,
        className,
        bsStyle: error && dirty && "error" || void 0,
        label: /* @__PURE__ */ React.createElement(Label, { label, error }),
        help
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      ...restProps,
      id,
      type,
      onChange,
      onBlur: checkValidity,
      className,
      bsStyle: error && dirty && "error" || void 0,
      defaultValue: type !== "select" && type !== "file" && value || void 0,
      value: type === "select" && value || void 0,
      label: /* @__PURE__ */ React.createElement(Label, { label, error }),
      help
    }
  );
};
export default ValidatedInput;
